// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
export {};
